import React from 'react'
import { Row, Col } from 'react-bootstrap'
import {
  PAGE_URL_CATALOG,
  PAGE_URL_ACTIVE,
  PAGE_URL_CART,
  PAGE_URL_HISTORY,
  PAGE_URL_PROFILE,
} from 'SiteURLs'

interface ITopNavExpLinkAuthProps {
  onClick: VoidFunction
  onLogout: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const TopNavExpLinkAuth: React.FC<ITopNavExpLinkAuthProps> = ({ onClick, onLogout }) => {
  return (
    <>
      <div className='sm-height-col-disp'>
        <Row>
          <Col>
            <a
              href={'#/' + PAGE_URL_CATALOG}
              onClick={onClick}
              className='font-rem-15 nav-link'
            >
              Каталог
            </a>
          </Col>
        </Row>

        <Row>
          <Col>
            <a
              href={'#/' + PAGE_URL_ACTIVE}
              onClick={onClick}
              className='font-rem-15 nav-link'
            >
              Заказы
            </a>
          </Col>
        </Row>

        <Row>
          <Col>
            <a
              href={'#/' + PAGE_URL_CART}
              onClick={onClick}
              className='font-rem-15 nav-link'
            >
              Корзина
            </a>
          </Col>
        </Row>
      </div>

      <div className='sm-height-col-disp'>
        <Row>
          <Col>
            <a
              href={'#/' + PAGE_URL_HISTORY}
              onClick={onClick}
              className='font-rem-15 nav-link'
            >
              История
            </a>
          </Col>
        </Row>
        <Row>
          <Col>
            <a
              href={'#/' + PAGE_URL_PROFILE}
              onClick={onClick}
              className='font-rem-15 nav-link'
            >
              Профиль
            </a>
          </Col>
        </Row>
      </div>
      <div className='sm-height-col-disp'>
        <Row>
          <Col>
            <a href='#/' className='font-rem-15 nav-link' onClick={onLogout}>
              Выход
            </a>
          </Col>
        </Row>
      </div>
    </>
  )
}
export default TopNavExpLinkAuth
